import axios from "axios";

export default {
  getAll() {
    let tokenAuth = localStorage.getItem("access_token");
    let headerAuth = { headers: { Authorization: `${tokenAuth}` } };

    return axios
      .get("api/colores", headerAuth)
      .then((result) => {
        return result.data;
      })
      .catch((e) => {
        console.log(e);
        throw e;
      });
  },

  get(id) {
    let tokenAuth = localStorage.getItem("access_token");
    let headerAuth = { headers: { Authorization: `${tokenAuth}` } };

    return axios
      .get(`api/color/${id}`, headerAuth)
      .then((result) => {
        return result.data;
      })
      .catch((e) => {
        console.log(e);
        throw e;
      });
  },

  add(color) {
    let tokenAuth = localStorage.getItem("access_token");
    let headerAuth = { headers: { Authorization: `${tokenAuth}` } };

    return axios
      .post("api/color", color, headerAuth)
      .then((result) => {
        return result.data;
      })
      .catch((e) => {
        console.log(e);
        throw e;
      });
  },

  update(color) {
    let tokenAuth = localStorage.getItem("access_token");
    let headerAuth = { headers: { Authorization: `${tokenAuth}` } };

    return axios
      .put(`api/color/${color.colorId}`, color, headerAuth)
      .then((result) => {
        return result.data;
      })
      .catch((e) => {
        console.log(e);
        throw e;
      });
  },

  delete(id) {
    let tokenAuth = localStorage.getItem("access_token");
    let headerAuth = { headers: { Authorization: `${tokenAuth}` } };

    return axios
      .delete(`api/color/${id}`, headerAuth)
      .then((result) => {
        return result.data;
      })
      .catch((e) => {
        console.log(e);
        throw e;
      });
  },
};
